import React from "react";
import classnames from "classnames";
import styles from "./SageErrorAlert.module.scss";

interface Props {
    text?: string;
    tryAgainAction?: () => void;
    onDismiss?: () => void;
}

const SageErrorAlert: React.FC<Props> = ({
    text,
    tryAgainAction,
    onDismiss,
}) => {
    return (
        <div
            style={{ position: "fixed" }}
            className={classnames(
                styles.container,
                "alert alert-danger alert-dismissible fade show"
            )}
        >
            {text || "An unknown error occurred."}
            {tryAgainAction && (
                <a href="#" className="alert-link" onClick={tryAgainAction}>
                    Try Again
                </a>
            )}
            {onDismiss && (
                <button
                    onClick={onDismiss}
                    type="button"
                    className="close"
                    data-dismiss="alert"
                    aria-label="Close"
                >
                    <span aria-hidden="true">&times;</span>
                </button>
            )}
        </div>
    );
};

export default SageErrorAlert;
